import { render, staticRenderFns } from "./hue-slider.vue?vue&type=template&id=5cdc43b1&"
import script from "./hue-slider.vue?vue&type=script&lang=js&"
export * from "./hue-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cdc43b1')) {
      api.createRecord('5cdc43b1', component.options)
    } else {
      api.reload('5cdc43b1', component.options)
    }
    module.hot.accept("./hue-slider.vue?vue&type=template&id=5cdc43b1&", function () {
      api.rerender('5cdc43b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/color-picker/src/components/hue-slider.vue"
export default component.exports